<main class="c-main">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12"></div>
            <!-- ngFor for para percorrer o array de erros e se existir erros imprimir na tela -->
            <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">
                {{ erro }}
            </div>
        </div>
        <div class="mat-elevation-z8">
            <mat-card>
                <mat-card-title>
                    <mat-icon>color_lens</mat-icon>
                    Estoque
                </mat-card-title>
                <mat-tab-group mat-align-tabs="start" #tabGroup>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon>add</mat-icon>
                            Cadastrar entrada estoque
                        </ng-template>
                        <!-- CADASATRANDO OBJETO INICIO -->
                        <mat-card>
                            <form [formGroup]="formulario" (ngSubmit)="submit()">
                                <!--passa qual é o formulario e o evento-->
                            <div class="row">
                                <div class="col-12" style="display: flex;">
                                    <div class="col-2">
                                        <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                            <mat-label>ID</mat-label>
                                            <input formControlName="id" matInput readonly>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-3"> 
                                        <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                            <mat-label>Cod Fornecedor</mat-label>
                                            <input maxlength="13" formControlName="supplier" mask="separator.0" matInput
                                                placeholder="ex: 0000000000000" (change)="buscarFornecedor()">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-7"> 
                                        <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                            <mat-label>Fornecedor</mat-label>
                                            <input matInput value="{{nameFornecedor}}" disabled>
                                        </mat-form-field>                                    
                                    </div>
                                </div>
                                <div class="col-12" style="display: flex;">
                                    <div class="col-2"> 
                                        <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                            <mat-label>Cod produto</mat-label>
                                            <input maxlength="13" formControlName="product" mask="separator.0" matInput
                                                placeholder="ex: 0000000000000" (change)="buscarProduto()">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-6"> 
                                        <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                            <mat-label>Produto</mat-label>
                                            <input matInput value="{{nameProduct}}" disabled>
                                        </mat-form-field>                                    
                                    </div> 
                                    <div class="col-2">
                                        <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                            <mat-label>Quantidade</mat-label>
                                            <input formControlName="qdtProduct" matInput >
                                        </mat-form-field>
                                    </div> 
                                    <div class="col-2">
                                        <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                            <mat-label>Valor Total</mat-label>
                                            <span matPrefix>R$ &nbsp;</span>
                                                <input formControlName="amountPaid" matInput currencyMask placeholder="Digite o valor" 
                                                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" required>
                                            <mat-error *ngIf="formulario.controls.amountPaid.hasError('required')">Preço é
                                                obrigatório! Informe 0 para itens sem preço.
                                            </mat-error>
                                        </mat-form-field>
                                    </div>                              
                                </div>
                            </div>                            

                                <div class="row justify-content-between">
                                    <div class="col-6">
                                        <!-- habilita desabilita botão com o forma validate -->
                                        <button (click)="limparFormulario()" mat-raised-button>
                                            <mat-icon>insert_drive_file</mat-icon>
                                            Limpar
                                        </button>
                                    </div>
                                    <div class="col-6" align="right">
                                        <!-- habilita desabilita botão com o forma validate -->
                                        <button [disabled]="!formulario.valid" mat-raised-button color="primary">
                                            <mat-icon>save</mat-icon>
                                            Salvar
                                        </button>
                                    </div>
                                </div>
                            </form>
                           
                        </mat-card>
                    </mat-tab>
                    <!-- CADASATRANDO OBJETO INICIO -->

                    <!-- LISTANDO TODAS INICIO -->
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon>list</mat-icon>
                            Listar Entradas
                        </ng-template>
                        <mat-card>
                            <!-- //inicio da tabela -->
                            <table mat-table [dataSource]="listEstoque" class="full-width">
                                <!-- Coluna ID -->
                                <ng-container matColumnDef="id">
                                    <th mat-header-cell *matHeaderCellDef> ID </th>
                                    <td mat-cell *matCellDef="let estoque"> {{ estoque.id }} </td>
                                </ng-container>

                                <ng-container matColumnDef="createdAt">
                                    <th mat-header-cell *matHeaderCellDef> Data Entrada </th>
                                    <td mat-cell *matCellDef="let estoque"> {{ estoque.createdAt | date : 'dd/MM/yyyy HH:mm'}} </td>
                                </ng-container>

                                <!-- Coluna Nome -->
                                <ng-container matColumnDef="fornecedor">
                                    <th mat-header-cell *matHeaderCellDef> Fornecedor </th>
                                    <td mat-cell *matCellDef="let estoque"> {{ estoque.fornecedor }} </td>
                                </ng-container>
                               
                                <ng-container matColumnDef="produto">
                                    <th mat-header-cell *matHeaderCellDef> Produto </th>
                                    <td mat-cell *matCellDef="let estoque"> {{ estoque.produto }} </td>
                                </ng-container>

                                <ng-container matColumnDef="qdtProduct">
                                    <th mat-header-cell *matHeaderCellDef> Quantidade </th>
                                    <td mat-cell *matCellDef="let estoque"> {{ estoque.qdtProduct }} </td>
                                </ng-container>

                                <ng-container matColumnDef="amountPaid">
                                    <th mat-header-cell *matHeaderCellDef> Total </th>
                                    <td mat-cell *matCellDef="let estoque"> {{ estoque.amountPaid  | currency:'BRL' }} </td>
                                </ng-container>           

                               <!--  <ng-container matColumnDef="excluir">
                                    <th mat-header-cell *matHeaderCellDef> Excluir </th>
                                    <td mat-cell *matCellDef="let estoque">
                                        <button (click)="openDialog(estoque.id)" mat-icon-button color="warn">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>
                               -->
                                <!-- definir como vai ser as linhas e a ordem das colunas -->
                                <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>
                                <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;"></tr>
                            </table>

                            <!-- paginação -->
                            <mat-paginator [length]="totalElementos" [pageSize]="tamanho"
                                [pageSizeOptions]="pageSizeOptions" (page)="paginar($event)">
                                <!-- evento de paginar -->
                            </mat-paginator>

                        </mat-card>
                    </mat-tab>
                    <!-- LISTANDO TODAS FIM -->
                </mat-tab-group>
            </mat-card>
        </div>
    </div>

</main>